import { useLayoutEffect } from 'react'
import { useDispatch } from 'react-redux'
import AuthExperienceActions from '../../../redux/actions/experiences/Auth'
import AuthService from '../../../services/Auth'
import { authorizeHttpClient, unAuthorizeHttpClient } from '../../../clients/mainHTTPClient'

const CheckAuthentication = () => {
  const dispatch = useDispatch()

  useLayoutEffect(
    () => {
      // Attach stored token before any child layout effects fire catalog fetches (avoids 401 race on refresh).
      const persistedToken = AuthService.GetAuthToken()
      if (persistedToken) {
        unAuthorizeHttpClient()
        authorizeHttpClient(persistedToken)
      }

      dispatch(
        AuthExperienceActions.verifyAuthentication()
      )
    },
    [dispatch]
  )

  return null
}

export default CheckAuthentication
